<template>
  <div>
    <div class="navigation">
      <router-link class="navigation__link" to="/">{{ $t("home") }}</router-link>
      <router-link class="navigation__link" to="/about">{{ $t("about") }}</router-link>
      <router-link class="navigation__link" to="/gallery">{{ $t("gallery") }}</router-link>
      <router-link class="navigation__link" to="/contact">{{ $t("contact") }}</router-link>
    </div>
    <div class="navigation__hamburger" @click="toggleMenu" :alt="smallDisplay">
      <img src="@/assets/icons/menu.svg" alt="Menu hamburger menu for mobile phones">
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuVisible: false
    };
  },
  methods: {
    toggleMenu() {
      return this.$store.dispatch("toggleMenu");
    }
  },
  computed: {
    smallDisplay() {
      return window.addEventListener("resize", () => {
        window.innerWidth > 900 ? this.$store.dispatch("hideMenu") : null;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.navigation {
  &__hamburger {
    width: 3rem;
    padding: 2rem;
    height: 3rem;
    display: none;
    position: relative;
    cursor: pointer;
    @include respond(big-desktop) {
      display: none;
    }
    @include respond(tab-land) {
      display: none;
    }
    @include respond(tab-port) {
      display: block;
    }
  }
  &__link {
    color: $fonts;
    margin-left: 6rem;
    text-decoration: none;
    text-transform: uppercase;
    font-size: $font-size-header;
    font-weight: 600;
    padding: 0.3rem 0;
    @include respond(tab-port) {
      display: none;
    }
    &:hover {
      border-bottom: 2px solid $fonts;
    }
  }
}
.router-link-exact-active {
  border-bottom: 2px solid $fonts;
}
</style>